var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevron16(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 16,
    viewBox: "0 0 8 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.792893 2.29289C0.402369 2.68342 0.402369 3.31658 0.792893 3.70711L5.08579 8L0.792893 12.2929C0.402369 12.6834 0.402369 13.3166 0.792893 13.7071C1.18342 14.0976 1.81658 14.0976 2.20711 13.7071L7.20711 8.70711C7.59763 8.31658 7.59763 7.68342 7.20711 7.29289L2.20711 2.29289C1.81658 1.90237 1.18342 1.90237 0.792893 2.29289Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevron16);
export default __webpack_public_path__ + "static/media/chevron_16.e6b98b34.svg";
export { ForwardRef as ReactComponent };